import axioPath from "api/axioPath";

export const getAccountDetailsApi = (locType, customerId, token) => (dispatch) => {
  return axioPath.get(`user/get_manage_account_data/${locType}`, {
    headers: {
      Authorization: token,
      UserType: 'external',
      id: customerId,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const deleteFlatFee = (location_id, flat_fee_id, token) => (dispatch) => {
  return axioPath.get("user/" + location_id + "/delete_flatfee/" + flat_fee_id, {
    headers: {
      Authorization: token,
      UserType: 'external',
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const updateFlatFee = (data, flat_fee_id, token) => (dispatch) => {
  return axioPath.post("user/update_flatfee/" + flat_fee_id, data, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const adminUpdateUserApi = (url, data, token) => (dispatch) => {
  return axioPath.post(url, data, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const checkIsZipCode = (zip, token) => () => {
  return axioPath.get(`internal/validate_zip_code/${zip}`, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const adminFetchLocationListApi = (locType, cusId, token) => (dispatch) => {
  // return axioPath.get(`internal/loc_and_cust_list/${id}`, {
  return axioPath.get(`internal/location_details/${cusId}/${locType}`, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const certificateListPTMS = (token, authId) => (dispatch) => {
  return axioPath.get(`tax/get_ecomm_token?id=${authId}`, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const certificateListDetails = (token, id) => (dispatch) => {
  return axioPath.get('tax/certificate_list?id=' + id, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};
export const getGenToken = (token, authId) => (dispatch) => {
  return axioPath.get('tax/certificate_list?id=' + authId, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });

};
export const adminFlatFeeAddApi = (id, data, token) => (dispatch) => {
  return axioPath.post(`user/add_flatfee/${id}`, data, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const adminAddLocationApi = (id, data, token) => (dispatch) => {
  return axioPath.post(`user/location/${id}/add`, data, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const adminAddLocationUserApi = (id, data, token) => (dispatch) => {
  return axioPath.post(`user/location_sub_user/${id}/add`, data, {
    headers: {
      Authorization: token,
      UserType: 'external'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};